import React, { Component, Fragment } from 'react'
import { MuiIconButton, MuiGrid, MuiClear, MuiTextField } from '../../ui/MaterialUIComponents';
import theme from '../../../assests/theme'
import lodashUtil from 'lodash';
import TimeComponent from '../school/weeklyCalendar/TimeComponent';
import { ToggleButtonGroup, ToggleButton } from '../../ui/customUIComponents/Toggle'
import { getHourMinStr } from '../school/weeklyCalendar/WeeklyCalendarUtil'
import { initWeeklyAvailability } from './WeeklyAvailabilityScheduleUtil'
export class AvailabilityScheduleComponent extends Component {
  constructor(props) {
    super(props)

    this.state = {
      toggleChange: false,
      weekDays: [],
      periodsDetailsForAfter: this.props.periodsArrayToDisplay,
      periodsDetailsForBefore: this.props.periodsArrayToDisplay,
      timeObj: {
        outFrom: this.props.schedule.outFrom,
        outUntill: this.props.schedule.outUntill,
        outFromStr: this.props.schedule.outFromStr,
        outUntillStr: this.props.schedule.outUntillStr,
      },

    }
  }


  onChange = (name, event, index) => {
    let selectedIndex = event.target.selectedIndex;
    this.props.schedule[name] = event.target.value
    let obj = { ...this.state.timeObj };
    obj[name] = event.target.value;
    this.setState({ timeObj: obj });

    if (name === "outFrom") {
      let periodsDetailsForBefore = JSON.parse(JSON.stringify(this.state.periodsDetailsForAfter))
      periodsDetailsForBefore.splice(0, selectedIndex + 1);

      // if user selects P4 for before and then selects P5 for after the value is not shown for before but is still saved. So we are clearing the field when he selects after. 
      this.props.schedule.outUntill = "";
      this.props.schedule.outUntillstr = "";
      obj.outUntill = ""
      obj.outUntillStr = ""
      this.setState({
        timeObj: obj,
        toggleChange: !this.state.toggleChange,
        periodsDetailsForBefore: periodsDetailsForBefore
      })
    }
    this.setState({
      toggleChange: !this.state.toggleChange,
    })
  }
  onOpen = (name, event, index) => {
    
    if (this.state.timeObj.outFrom !== undefined && this.state.timeObj.outFrom !== "") {
      if (this.state.timeObj.outUntill !== undefined && this.state.timeObj.outUntill !== "") {
        let selectedIndex = event.target.selectedIndex;
        let periodsDetailsForBefore = JSON.parse(JSON.stringify(this.state.periodsDetailsForAfter))
        periodsDetailsForBefore.splice(0, selectedIndex - 1);
        this.setState({
          toggleChange: !this.state.toggleChange,
          periodsDetailsForBefore: periodsDetailsForBefore
        })
      }
    }

  }
  handleWeekDayToggle = (event, day) => {
    if (lodashUtil.indexOf(this.props.schedule.weekDays, day) != -1) {

      this.props.schedule.weekDays.splice(lodashUtil.indexOf(this.props.schedule.weekDays, day), 1);

    } else {
      this.props.schedule.weekDays.push(day)
    }
    this.setState({
      toggleChange: !this.state.toggleChange
    })
  }


  handleClose = () => {

    this.setState({ open: false })
  };
  handleDelete = () => {
    this.props.removeWeeklyAvailabilitySchedule(this.props.index)
  }
  onClickOfSaveInGradePicker = (gradeDetails) => {
    this.props.assignedSubject.gradeDetails = gradeDetails;
    this.setState({ toggleChange: !this.state.toggleChange, open: false })
  }
  handleTimeChange = (date, label) => {
    if (date == "Invalid Date") {
    } else {
      date = date.setFullYear(1970, 0, 1)
      date = new Date(date);
      if (label === "Start Time") {
        this.props.schedule.outFrom = date
        this.props.schedule.outFromStr = getHourMinStr(date);
      } else if (label === "End Time") {
        this.props.schedule.outUntill = date
        this.props.schedule.outUntillStr = getHourMinStr(date);
      }
    }

    this.setState({
      toggleChange: !this.state.toggleChange
    })

  }
  // componentWillMount() {
  //   if (this.props.schedule.weekDays.length === 0) {

  //     let initObj = initWeeklyAvailability();

  //     this.props.schedule.outFromStr = initObj.outFromStr;
  //     this.props.schedule.outFrom = initObj.outFrom

  //     this.props.schedule.outUntillStr = initObj.outUntillStr;
  //     this.props.schedule.outUntill = initObj.outUntill;
  //   }
  // }
  render() {
    return (
      <Fragment>
        {this.props.isPreferredPeriod == false ?
          <MuiGrid container xs={12} direction='row'>
            <MuiGrid item container xs={5} style={theme.gridTableStyle} direction='row' justify='center' alignItems="center">
              <ToggleButtonGroup exclusive id="toggleGroup" value={this.props.schedule.weekDays} style={{ paddingTop: "3px", paddingBottom: "3px", width: '100%' }}
                onChange={(event, value) => {
                  this.handleWeekDayToggle(event, value)
                }}>
                <ToggleButton id="M" value="2" style={theme.dayToggleButtonForAvailabilityStyle}>M</ToggleButton>
                <ToggleButton id="T" value="3" style={theme.dayToggleButtonForAvailabilityStyle}>T</ToggleButton>
                <ToggleButton value="4" id="W" style={theme.dayToggleButtonForAvailabilityStyle}>W</ToggleButton>
                <ToggleButton value="5" id="TH" style={theme.dayToggleButtonForAvailabilityStyle}>T</ToggleButton>
                <ToggleButton value="6" id="F" style={theme.dayToggleButtonForAvailabilityStyle}>F</ToggleButton>
                <ToggleButton value="7" id="S" style={theme.dayToggleButtonForAvailabilityStyle}>S</ToggleButton>
                <ToggleButton value="1" id="Sun" style={theme.dayToggleButtonForAvailabilityStyle}>S</ToggleButton>
              </ToggleButtonGroup>
            </MuiGrid>
            <MuiGrid item xs={3} style={theme.gridTableStyle}>
              <TimeComponent
                {...this.props}
                label="Start Time"
                value={this.props.schedule.outFrom}
                handleTimeChange={this.handleTimeChange}
              />
            </MuiGrid>
            <MuiGrid item xs style={theme.gridTableStyle}>
              <TimeComponent
                {...this.props}
                label="End Time"
                value={this.props.schedule.outUntill}
                handleTimeChange={this.handleTimeChange}
              />
            </MuiGrid>
            < MuiGrid item style={theme.gridTableClearButtonStyle} justify="center " alignContent="center">
              <MuiIconButton onClick={() => this.handleDelete()} id="delete">
                <MuiClear style={{ color: theme.palette.grey.dark }} />
              </MuiIconButton>
            </ MuiGrid>
          </ MuiGrid>

          :

          /*
          * PREFERRED PERIODS
          */

          <MuiGrid container xs={12} direction='row' >
            <MuiGrid container xs={5} alignItems='center' justify='center' style={theme.gridTableStyle} >
              <ToggleButtonGroup exclusive id="toggleGroup" value={this.props.schedule.weekDays} style={{ width: '100%', padding: "3px", }} align="center"
                onChange={(event, value) => {
                  this.handleWeekDayToggle(event, value)
                }}>
                <ToggleButton id="M" value="2" style={theme.dayToggleButtonForPreferedPeriodsStyle}>M</ToggleButton>
                <ToggleButton id="T" value="3" style={theme.dayToggleButtonForPreferedPeriodsStyle}>T</ToggleButton>
                <ToggleButton value="4" id="W" style={theme.dayToggleButtonForPreferedPeriodsStyle}>W</ToggleButton>
                <ToggleButton value="5" id="TH" style={theme.dayToggleButtonForPreferedPeriodsStyle}>T</ToggleButton>
                <ToggleButton value="6" id="F" style={theme.dayToggleButtonForPreferedPeriodsStyle}>F</ToggleButton>
                <ToggleButton value="7" id="S" style={theme.dayToggleButtonForPreferedPeriodsStyle}>S</ToggleButton>
                <ToggleButton value="1" id="Sun" style={theme.dayToggleButtonForPreferedPeriodsStyle}>S</ToggleButton>
              </ToggleButtonGroup>
            </MuiGrid>

            {/* AFTER  */}
            <MuiGrid item xs={3} style={theme.gridTableSelectStyle}>
              < MuiTextField
                // variant="outlined"
                id="outFrom"
                style={{ width: "100%" }}
                select
                value={this.state.timeObj.outFrom}
                onChange={(event, index) => this.onChange("outFrom", event, index)}
                SelectProps={{
                  native: true, disableUnderline: true,
                }} >
                <option style={{ display: 'none' }}>
                </option>
                {this.state.periodsDetailsForAfter.map((periodName, index) => <option
                  value={periodName}>{periodName}</option>)}}
              </ MuiTextField>
            </MuiGrid>

            {/* BEFORE */}
            <MuiGrid item xs style={theme.gridTableSelectStyle}>
              < MuiTextField
                id="outUntill"
                //variant="outlined"
                style={{ width: "100%" }}
                select
                value={this.state.timeObj.outUntill}
                onChange={(event) => this.onChange("outUntill", event)}
                onFocus={(event, index) => this.onOpen("outFrom", event, index)}
                SelectProps={{
                  native: true, disableUnderline: true
                }} >
                <option style={{ display: 'none' }}>
                </option>
                {this.state.periodsDetailsForBefore.map((periodName, index) => <option
                  value={periodName}>{periodName}</option>)}}
              </ MuiTextField>
            </MuiGrid>

            < MuiGrid item style={theme.gridTableClearButtonStyle} justify="center " alignContent="center">
              <MuiIconButton onClick={() => this.handleDelete()} id="delete">
                <MuiClear style={{ color: theme.palette.grey.dark }} />
              </MuiIconButton>
            </ MuiGrid>
          </ MuiGrid>}
      </Fragment>
    )
  }
}

export default AvailabilityScheduleComponent

